type TProduct = {
    name?: string,
    img?: string,
    description?: string,
    url?: string,
    lowPrice?: string,
    highPrice?: string,
    count?: string,
}

export function createProductSchema(product: TProduct) {
    return {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": product.name,
        "image": product.img,
        "description": product.description,
        "url": product.url,
        "brand": {
            "@type": "Brand",
            "name": "Navatel"
        },
        "offers": {
            "@type": "AggregateOffer",
            "priceCurrency": "IRR",
            "lowPrice": product.lowPrice,
            "highPrice": product.highPrice,
            "offerCount": product.count,
            "availability": "https://schema.org/InStock",
            "url": product.url
        }
    }
};